import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useCopyPlaylist = ({ onSuccess }) => {
  const { onSubmit: handleCopy } = useFetch('copy-playlist', Api.PLAYLIST_COPY);

  const onCopy = (id, name) => () =>
    handleCopy({ pathParams: { id }, body: { name }, onSuccess });

  return {
    onCopy,
  };
};

export default useCopyPlaylist;
